import apiRequest from "../../utils/apiRequest";

/**
 * Service motifs de visite (catalogue géré par le cabinet). Lecture pour tout
 * le personnel ; création / modification / suppression réservées au médecin
 * et à l'administrateur (contrôlé côté back).
 */

/** Motifs actifs, triés, pour l'ajout en file : tableau plat `VisitReasonApi[]`. */
export const getVisitReasonsLookup = () => apiRequest.get(`/visit-reasons/lookup`);

/** Écran de gestion : catalogue paginé (`PageMapper.toMap`), actifs et désactivés. */
export const getVisitReasons = async ({ search = "", page = 0, size = 20 } = {}) => {
  const qs = new URLSearchParams({ search, page: String(page), size: String(size) }).toString();
  return apiRequest.get(`/visit-reasons?${qs}`);
};

/** Crée un motif. Renvoie l'id (`Long`). payload = `VisitReasonPayload`. */
export const createVisitReason = (payload) => apiRequest.post(`/visit-reasons`, payload);

/** Modifie un motif. Renvoie l'id (`Long`). */
export const updateVisitReason = (id, payload) => apiRequest.put(`/visit-reasons/${id}`, payload);

/** Suppression douce : les entrées de file existantes gardent leur motif. */
export const deleteVisitReason = (id) => apiRequest.del(`/visit-reasons/${id}`);
